import BaseResource from './index'
import LocationResource from './location'
import UserResource from './user'

export default class ReservationSeatingGroupResource extends BaseResource {
    static endpoint = '/reservations/seating/groups'

    static related() {
        return {
            location: LocationResource,
            created_by: UserResource,
        }
    }

    static async createGroup({ source = 'CHECKOUT', name = '', reservations = [], racers = [] }) {
        const response = await this.client.post(`${this.endpoint}/`, { source, name, reservations, racers })
        return new ReservationSeatingGroupResource(response.data)
    }

    static async mine() {
        const response = await this.client.get(`${this.endpoint}/mine/`)
        const negotiate = this.client.negotiateContent(ReservationSeatingGroupResource)
        return negotiate(response).resources
    }

    async addRacers(racers) {
        const response = await ReservationSeatingGroupResource.client.post(`${ReservationSeatingGroupResource.endpoint}/${this.id}/racers/`, { racers })
        return new ReservationSeatingGroupResource(response.data)
    }

    seats() {
        return this.attributes.readonly_values?.seats || []
    }

    invitees() {
        return this.attributes.readonly_values?.invitees || []
    }

    bookedByName() {
        return this.attributes.readonly_values?.booked_by_display_name || 'Unknown'
    }

    calendarIds() {
        return this.seats()
            .map((seat) => seat.calendar)
            .filter((id) => !!id)
    }
}
